import React, { useEffect, useState } from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import QueryApiService from '../utils/reactQueryApi';
import { API_URL, HOST_URL } from '../constants/api';

const PauseIcon = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: '#5956E9' }}
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1z"
      fill="currentColor"
    />
  </svg>
);

const Download = () => {
  const [data, setData] = useState([]);
  const [settings, setSettings] = useState(null);
  const reactQueryDataApi = new QueryApiService('downloads');
  const settingsApi = new QueryApiService('settings');

  useEffect(() => {
    const fetchData = async () => {
      const [downloadsResult, settingsResult] = await Promise.all([
        reactQueryDataApi.getData('?sort=createdAt'),
        settingsApi.getData(),
      ]);
      setData(downloadsResult?.data || []);
      setSettings(settingsResult?.data);
    };
    fetchData();
  }, []);

  if (settings?.downloadPause) {
    return (
      <>
        <SEO title="التحديثات" />
        <ColorSwitcher />
        <main className="main-wrapper">
          <HeaderOne />
          <div className="breadcrum-area breadcrumb-banner">
            <div className="container">
              <div className="row justify-content-center" style={{ marginTop: '-40px' }}>
                <div className="col-lg-8">
                  <div className="case-study-featured" style={{ marginTop: '0' }}>
                    <div className="section-heading heading-left"></div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '50px 0',
                        textAlign: 'center',
                        background: 'rgba(89, 86, 233, 0.05)',
                        borderRadius: '30px',
                        margin: '20px 0',
                      }}
                    >
                      <PauseIcon />
                      <div
                        style={{
                          marginTop: '30px',
                          maxWidth: '500px',
                        }}
                      >
                        <h3
                          className="title"
                          style={{
                            color: '#5956E9',
                            marginBottom: '20px',
                            fontSize: '24px',
                          }}
                        >
                          تم إيقاف التحميل مؤقتاً
                        </h3>
                        <p
                          style={{
                            fontSize: '18px',
                            color: '#737589',
                            lineHeight: '1.6',
                          }}
                        >
                          عذراً، التحميل غير متاح حالياً. يرجى المحاولة مرة أخرى لاحقاً.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CtaLayoutOne />
          <FooterOne parentClass="" />
        </main>
      </>
    );
  }

  return (
    <>
      <SEO title="التحديثات" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <div className="breadcrum-area breadcrumb-banner">
          <div className="container">
            <div className="row justify-content-center">
              <h1 className="title h2" dangerouslySetInnerHTML={{ __html: 'التحديثات' }}></h1>
              <p
                dangerouslySetInnerHTML={{
                  __html: 'يمكنك تحميل اخر التحديثات من هتا',
                }}
              ></p>
            </div>
            <hr />
            <div className="row justify-content-center">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">المنظومة</th>
                    <th scope="col">وصف قصير</th>
                    <th scope="col">تاريخ التحديث</th>
                    <th scope="col">توقيت التحديث</th>
                    <th scope="col">التحميل</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, i) => {
                    return (
                      <tr key={item._id || i}>
                        <th scope="row">{i + 1}</th>
                        <td>{item?.name}</td>
                        <td>{item?.breif}</td>
                        <td>{item?.updatedAt?.slice(0, 10)}</td>
                        <td>{item?.updatedAt?.substr(11, 5)}</td>
                        <td>
                          <a href={HOST_URL + item?.file}>{item?.file?.replace('uploads', '')} </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Download;
